module.exports = __webpack_public_path__ + "media/images/territory_landing_pages/hero_banner/component/haircut-desktop-10f46046fa9f659317ebf40363241d83.jpg";